import React from 'react';
import { Box, Typography } from '@mui/material';

import ecommerceIcon from '../../assets/img/mobileLanding/service-icon1.png';
import webCloudIcon from '../../assets/img/mobileLanding/service-icon2.png';
import mobileIcon from '../../assets/img/mobileLanding/service-icon3.png';
import processIcon from '../../assets/img/mobileLanding/service-icon4.png';
import useDevice from 'hooks/useDevice';

function CoreServices({ type }: { type: string }) {
    const { screenWidth } = useDevice();
    const services = [
        {
            title: 'Enterprise',
            seoTitle: 'Enterprise eCommerce Development Dubai & Malappuram',
            subtitle: 'e-commerce',
            icon: ecommerceIcon,
            iconColor: '#E91E63',
            textGradient: 'linear-gradient(360deg, #993FC3 0%, #A532C5 100%)',
        },
        {
            title: 'Web& Cloud Applications',
            seoTitle: 'Web & Cloud Application Development Kerala',
            subtitle: '',
            icon: webCloudIcon,
            iconColor: '#2196F3',
            textGradient: 'linear-gradient(360deg, #9048C1 0%, #8652C0 100%)',
        },
        {
            title: 'Android & ios Mobile',
            seoTitle: 'Mobile App Development Company Kerala - Android & iOS',
            subtitle: 'Applications',
            icon: mobileIcon,
            iconColor: '#9C27B0',
            textGradient: 'linear-gradient(180deg, #7D5CBE 0%, #7366BD 100%)',
        },
        {
            title: 'Process Optimization,',
            seoTitle: 'Business Process Optimization & Workflow Automation Kerala',
            subtitle: 'System Blueprint & UI/UX',
            icon: processIcon,
            iconColor: '#FF9800',
            textGradient: 'linear-gradient(360deg, #607ABA 0%, #6A6FBC 100%)',
        },
    ];

    return (
        <Box sx={{ background: "white" }}>

            <Box
                sx={{
                    backgroundColor: 'white',
                    padding: '40px 24px',
                    pb: 0,
                    maxWidth: "450px",
                    margin: "auto"
                }}
            >
                {/* Section Heading */}
                <Typography
                    variant="h3"
                    className='font-satoshi-bold'
                    title="Custom Software Development Services Kerala"
                    sx={{
                        background: 'linear-gradient(270.11deg, #177BFF 23.63%, #0F1C3F 123.03%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        fontSize: '28px',
                        textAlign: type === 'web' ? 'center' : 'start',
                        mb: 3,
                    }}
                >
                    Our Core Services
                </Typography>

                {/* Services List */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2.5,
                        mb: 5,
                    }}
                >
                    {services.map((service, index) => (
                        <Box
                            key={index}
                            title={service.seoTitle}
                            sx={{
                                background: 'white',
                                border: '1px solid transparent',
                                borderRadius: '50px',

                                backgroundImage: 'linear-gradient(white, white), linear-gradient(180deg, #39C664 0%, #45D1D6 100%)',
                                backgroundOrigin: 'border-box',
                                backgroundClip: 'padding-box, border-box',
                                padding: '20px 24px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2.5,
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateX(8px)',
                                    boxShadow: '0 4px 12px rgba(57, 198, 100, 0.3)',
                                },
                            }}
                        >
                            {/* Icon Circle */}
                            <Box
                                sx={{
                                    width: screenWidth < 330 ? '40px' : '60px',
                                    height: screenWidth < 330 ? '40px' : '60px',
                                    borderRadius: '50%',
                                    border: '1px solid transparent',
                                    background: 'white',
                                    backgroundImage: 'linear-gradient(white, white), linear-gradient(180deg, #39C664 0%, #45D1D6 100%)',
                                    backgroundOrigin: 'border-box',
                                    backgroundClip: 'padding-box, border-box',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <img src={service.icon} alt={service.seoTitle} title={service.seoTitle} style={{ objectFit: "cover" }} />
                            </Box>

                            {/* Service Text */}
                            <Box>
                                <Typography
                                    variant="h6"
                                    className='font-satoshi-bold'
                                    sx={{
                                        // background: service.textGradient,
                                        // WebkitBackgroundClip: 'text',
                                        // WebkitTextFillColor: 'transparent',
                                        // backgroundClip: 'text',
                                        color: '#333333',
                                        fontSize: screenWidth < 330 ? '16px' : '20px',
                                        lineHeight: 1.2,
                                    }}
                                >
                                    {service.title}
                                    {service.subtitle && (
                                        <>
                                            <br />
                                            {service.subtitle}
                                        </>
                                    )}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>

                {/* Description Text with Gradient Background */}
                <Box
                    sx={{
                        width: 'calc(100% + 48px)',
                        mx: -3,
                        px: type === 'web' ? 0 : 3,
                        pt: 0,
                        pb: 4,
                        background: 'linear-gradient(180deg, #FFFFFF 71.22%, rgba(234, 243, 240, 0.4) 100%)',
                    }}
                >
                    <Typography
                        variant="body1"
                        className='font-satoshi-medium'
                        sx={{
                            color: '#333333',
                            fontSize: '14px',
                            lineHeight: 1.7,
                            textAlign: type === 'web' ? 'center' : 'left',
                            px: 0,
                        }}
                    >
                        We {' '}
                        <Box component="span" sx={{ fontWeight: 700 }}>
                            map your business process
                        </Box>
                        , design the right{' '} <br />
                        <Box component="span" sx={{ fontWeight: 700 }}>
                            system blueprint
                        </Box>{' '}
                        and then build custom ERPs, e-commerce and apps that replace manual,
                        scattered work with one Optimised system that can confidently scale with you
                    </Typography>
                </Box>
            </Box>
        </Box>

    );
}

export default CoreServices;
